import React from 'react'
import { Modal } from 'antd'
import './index.css'
const ModalBox = ({ children, title,okText,visible, onCancel, width, footer, loading,cname }) => {
    return (
        <div>
            <Modal
                title={title}
                open={visible}
                maskClosable={false}
                destroyOnClose={true}
                forceRender={false}
                onCancel={() => onCancel()}
                width={width ? width : 400}
                confirmLoading={loading}
                cancelButtonProps={{ disabled: true }}
                okText=""
                cancelText=""
                className='bimModal'
            >	
		
				<div style={{position: 'absolute',left:'50px',top:'70px',fontWeight:'500'}}>
					{cname}
					
				</div>
		
                {children}
            </Modal>
        </div>
    )
}

export default ModalBox
